import { ReduxStore } from 'store/types';

function getAvailableDocuments(state: ReduxStore): string[] {
  return state.intervention.getDocuments.availableDocuments;
}

export default getAvailableDocuments;
